module.exports = __webpack_public_path__ + "img/ic_alarm_clock_1.1bbe040f.png";